import React from "react"
import Footer from "../components/footer"
import Navbar from "../components/nav"

function FastingSenseTerms() {
  return (
    <>
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="home">
        <div className="container mt-125 mb-50">
          <div className="card-body shadow">
            <h4>Terms and Conditions for FastingSense: Fasting Tracker</h4>
            <br />
            <p><strong>Last Updated: January 28, 2026</strong></p>
            <p><strong>Developer:</strong> MWX Apps</p>
            <p><strong>App Name:</strong> FastingSense: Fasting Tracker</p>
            <p><strong>Package Name:</strong> mwxapps.fastingsense.app</p>
            <hr />

            <h5>Introduction</h5>
            <p>
              These Terms and Conditions ("Terms", "Terms and Conditions") govern your relationship with the FastingSense: Fasting Tracker mobile application (the "App") operated by MWX Apps ("us", "we", or "our").
            </p>
            <p>
              Please read these Terms and Conditions carefully before using our App. Your access to and use of the App is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who access or use the App.
            </p>
            <p>
              <strong>By downloading, installing, or using the App, you agree to be bound by these Terms. If you disagree with any part of these Terms, then you may not access the App.</strong>
            </p>
            <hr />

            <h5>1. Acceptance of Terms</h5>
            <p>
              By creating an account, accessing, or using FastingSense, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree to these terms, you must not use the App.
            </p>
            <hr />

            <h5>2. Eligibility and Age Restrictions</h5>
            <p>
              <strong>Age Requirement:</strong> FastingSense is intended for use by individuals who are at least 18 years of age. By using the App, you represent and warrant that you are at least 18 years old.
            </p>
            <p>
              <strong>Parental Consent:</strong> If you are under 18 years of age, you must not use this App. Intermittent fasting and caloric restriction may not be appropriate for minors.
            </p>
            <p>
              <strong>Health Status:</strong> By using the App, you confirm that you do not have any medical conditions that would make fasting dangerous or inappropriate without medical supervision.
            </p>
            <hr />

            <h5>3. License and Permitted Use</h5>
            <h6>3.1 License Grant</h6>
            <p>
              MWX Apps grants you a limited, non-exclusive, non-transferable, revocable license to download, install, and use FastingSense on your personal mobile device solely for your personal, non-commercial use, subject to these Terms.
            </p>
            <h6>3.2 Restrictions</h6>
            <p>You agree NOT to:</p>
            <ul>
              <li>Copy, modify, distribute, sell, or lease any part of the App</li>
              <li>Reverse engineer, decompile, or attempt to extract the source code of the App</li>
              <li>Remove, alter, or obscure any proprietary notices (copyright, trademark, etc.) on the App</li>
              <li>Use the App for any illegal, unauthorized, or commercial purposes</li>
              <li>Attempt to bypass any security measures or access restrictions</li>
              <li>Use the App in any way that could damage, disable, overburden, or impair the App</li>
              <li>Upload viruses, malware, or any harmful code</li>
              <li>Impersonate any person or entity or misrepresent your affiliation</li>
            </ul>
            <hr />

            <h5>4. Intellectual Property Rights</h5>
            <p>
              The App and its original content (excluding user-generated content), features, and functionality are and will remain the exclusive property of MWX Apps and its licensors. The App is protected by copyright, trademark, and other laws of both Turkey and foreign countries.
            </p>
            <p>
              Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of MWX Apps.
            </p>
            <hr />

            <h5>5. User-Generated Content and Data</h5>
            <h6>5.1 Your Data</h6>
            <p>
              You retain all rights to the health and personal data you input into the App (fasting logs, meal entries, weight data, etc.). We do not claim ownership of your data.
            </p>
            <h6>5.2 Data Storage</h6>
            <p>
              All your data is stored locally on your device. We do not have access to your data, as it is never transmitted to our servers. You are solely responsible for maintaining the security of your device and any data exports you create.
            </p>
            <h6>5.3 Data Loss</h6>
            <p>
              We are not responsible for any loss of data due to device failure, app uninstallation, device reset, or any other cause. We recommend regularly exporting your data as a backup.
            </p>
            <hr />

            <h5>6. Medical Disclaimer and Health Information</h5>
            <h6>6.1 Not Medical Advice</h6>
            <p>
              <strong>IMPORTANT:</strong> FastingSense is a wellness tracking tool and is NOT a medical device, medical service, or substitute for professional medical advice, diagnosis, or treatment.
            </p>
            <p>
              The App provides information and tracking features for intermittent fasting and nutrition monitoring. This information is for educational and informational purposes only and should not be considered medical advice.
            </p>
            <h6>6.2 Consult Healthcare Providers</h6>
            <p>
              <strong>You must consult with a qualified healthcare provider before starting any fasting regimen, diet, or exercise program.</strong> This is especially important if you:
            </p>
            <ul>
              <li>Have diabetes, cardiovascular disease, or any chronic medical conditions</li>
              <li>Are pregnant, breastfeeding, or trying to conceive</li>
              <li>Are under 18 or over 65 years of age</li>
              <li>Take medications that require food intake</li>
              <li>Have a history of eating disorders</li>
              <li>Have any health concerns or medical conditions</li>
            </ul>
            <h6>6.3 No Liability for Health Outcomes</h6>
            <p>
              We are not responsible for any health consequences, injuries, or adverse effects resulting from your use of the App or any fasting, dietary, or exercise activities you undertake. You assume all risks associated with fasting and using the App.
            </p>
            <h6>6.4 Accuracy of Information</h6>
            <p>
              While we strive for accuracy, we do not guarantee the accuracy, completeness, or reliability of any nutritional data, health information, or calculations provided by the App. Nutritional data from third-party sources (OpenFoodFacts, USDA) may contain errors.
            </p>
            <hr />

            <h5>7. Third-Party Services and Links</h5>
            <h6>7.1 Third-Party APIs</h6>
            <p>
              The App uses third-party services for specific features:
            </p>
            <ul>
              <li><strong>OpenFoodFacts API:</strong> For barcode scanning and nutritional data</li>
              <li><strong>USDA FoodData Central:</strong> For enhanced nutritional information</li>
              <li><strong>Google Health Connect:</strong> For optional sleep data synchronization</li>
            </ul>
            <p>
              Your use of these third-party services is subject to their respective terms and privacy policies. We are not responsible for the content, accuracy, or practices of third-party services.
            </p>
            <h6>7.2 External Links</h6>
            <p>
              The App may contain links to third-party websites or services. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
            </p>
            <hr />

            <h5>8. Privacy and Data Protection</h5>
            <p>
              Your privacy is important to us. Our collection, use, and protection of your personal and health data is governed by our <a href="/fastingsense/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </p>
            <p>
              By using the App, you acknowledge that you have read and understood our Privacy Policy and consent to the data practices described therein.
            </p>
            <p>
              <strong>Key Privacy Points:</strong>
            </p>
            <ul>
              <li>All data is stored locally on your device</li>
              <li>We do not operate servers that store your personal information</li>
              <li>No account or registration required</li>
              <li>We do not sell or share your data with third parties for advertising</li>
            </ul>
            <hr />

            <h5>9. Prohibited Uses</h5>
            <p>You agree not to use the App:</p>
            <ul>
              <li>In any way that violates any applicable national or international law or regulation</li>
              <li>To exploit, harm, or attempt to exploit or harm minors in any way</li>
              <li>To transmit, or procure the sending of, any advertising or promotional material without our prior written consent</li>
              <li>To impersonate or attempt to impersonate MWX Apps, another user, or any other person or entity</li>
              <li>In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent, or harmful</li>
              <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the App</li>
            </ul>
            <hr />

            <h5>10. Disclaimers and Warranties</h5>
            <h6>10.1 "As Is" and "As Available"</h6>
            <p>
              THE APP IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR COURSE OF PERFORMANCE.
            </p>
            <h6>10.2 No Warranty of Accuracy</h6>
            <p>
              MWX Apps does not warrant that:
            </p>
            <ul>
              <li>The App will function uninterrupted, securely, or be error-free</li>
              <li>Defects will be corrected</li>
              <li>The App or the servers that make it available are free of viruses or other harmful components</li>
              <li>The nutritional data, calculations, or health information provided is accurate, complete, or reliable</li>
            </ul>
            <h6>10.3 Use at Your Own Risk</h6>
            <p>
              Your use of the App is at your sole risk. You are solely responsible for any damage to your device, loss of data, or any other harm resulting from using the App.
            </p>
            <hr />

            <h5>11. Limitation of Liability</h5>
            <p>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL MWX APPS, ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS, OR AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
            </p>
            <ul>
              <li>Your access to or use of or inability to access or use the App</li>
              <li>Any conduct or content of any third party on the App</li>
              <li>Any content obtained from the App</li>
              <li>Unauthorized access, use, or alteration of your transmissions or content</li>
              <li>Any health consequences, injuries, or adverse effects from fasting or using the App</li>
            </ul>
            <p>
              WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, WHETHER OR NOT WE HAVE BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <hr />

            <h5>12. Indemnification</h5>
            <p>
              You agree to defend, indemnify, and hold harmless MWX Apps and its licensors, affiliates, officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to:
            </p>
            <ul>
              <li>Your violation of these Terms</li>
              <li>Your use or misuse of the App</li>
              <li>Your violation of any third-party rights, including intellectual property rights or privacy rights</li>
              <li>Any harm or damages caused by your actions or omissions</li>
            </ul>
            <hr />

            <h5>13. App Updates and Modifications</h5>
            <h6>13.1 Updates</h6>
            <p>
              We may periodically release updates, upgrades, or new versions of the App to add features, fix bugs, or improve performance. You may need to update the App to continue using it.
            </p>
            <h6>13.2 Changes to Features</h6>
            <p>
              We reserve the right to modify, suspend, or discontinue any feature or functionality of the App at any time without notice or liability.
            </p>
            <h6>13.3 Compatibility</h6>
            <p>
              The App is designed for Android devices. We do not guarantee compatibility with all devices, operating systems, or versions.
            </p>
            <hr />

            <h5>14. Termination</h5>
            <h6>14.1 Termination by You</h6>
            <p>
              You may terminate your use of the App at any time by uninstalling it from your device. Uninstalling the App will permanently delete all locally stored data.
            </p>
            <h6>14.2 Termination by Us</h6>
            <p>
              We may terminate or suspend your access to the App immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms.
            </p>
            <h6>14.3 Effect of Termination</h6>
            <p>
              Upon termination, your right to use the App will immediately cease. All provisions of these Terms which by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
            </p>
            <hr />

            <h5>15. Governing Law and Dispute Resolution</h5>
            <h6>15.1 Governing Law</h6>
            <p>
              These Terms shall be governed and construed in accordance with the laws of Turkey, without regard to its conflict of law provisions.
            </p>
            <h6>15.2 Dispute Resolution</h6>
            <p>
              Any disputes arising out of or relating to these Terms or the App shall be resolved through good faith negotiations. If negotiations fail, disputes shall be submitted to the competent courts of Turkey.
            </p>
            <hr />

            <h5>16. Changes to Terms and Conditions</h5>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect.
            </p>
            <p>
              What constitutes a material change will be determined at our sole discretion. By continuing to access or use our App after those revisions become effective, you agree to be bound by the revised terms.
            </p>
            <p>
              We will update the "Last Updated" date at the top of these Terms when changes are made.
            </p>
            <hr />

            <h5>17. Severability</h5>
            <p>
              If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law, and the remaining provisions will continue in full force and effect.
            </p>
            <hr />

            <h5>18. Entire Agreement</h5>
            <p>
              These Terms, together with our Privacy Policy, constitute the entire agreement between you and MWX Apps regarding the use of the App and supersede all prior and contemporaneous written or oral agreements.
            </p>
            <hr />

            <h5>19. No Waiver</h5>
            <p>
              Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. The waiver of any such right or provision will be effective only if in writing and signed by a duly authorized representative of MWX Apps.
            </p>
            <hr />

            <h5>20. Contact Information</h5>
            <p>
              If you have any questions, concerns, or feedback about these Terms and Conditions, please contact us:
            </p>
            <br />
            <p><strong>Developer:</strong> MWX Apps</p>
            <p><strong>Email:</strong> web-developer@outlook.com</p>
            <p><strong>App:</strong> FastingSense: Fasting Tracker</p>
            <p><strong>Package Name:</strong> mwxapps.fastingsense.app</p>
            <br />
            <p><strong>Response Time:</strong> We aim to respond to inquiries within 30 days.</p>
            <hr />

            <h5>21. Acknowledgment</h5>
            <p>
              BY DOWNLOADING, INSTALLING, OR USING FASTINGSENSE, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS AND CONDITIONS, UNDERSTAND THEM, AND AGREE TO BE BOUND BY THEM. YOU ALSO ACKNOWLEDGE THAT:
            </p>
            <ol>
              <li>You are at least 18 years of age</li>
              <li>You have consulted with a healthcare provider regarding fasting if you have any medical concerns</li>
              <li>The App is not a medical device and does not provide medical advice</li>
              <li>You use the App at your own risk</li>
              <li>All your data is stored locally on your device</li>
              <li>You are responsible for the security of your device and data</li>
            </ol>
            <br />
            <hr />
            <p><strong>Last Updated:</strong> January 28, 2026</p>
            <p><strong>Version:</strong> 1.0.0</p>
            <br />
            <p><em>These Terms and Conditions are designed to comply with Google Play policies, applicable consumer protection laws, and health app regulations.</em></p>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default FastingSenseTerms
